import React, { useEffect, useState } from "react";

const AgePopup = () => {
  const [show, setShow] = useState(false);

  // Check localStorage on load
  useEffect(() => {
    const isVerified = localStorage.getItem("ageVerified");
    if (!isVerified) {
      setShow(true);
    }
  }, []);

  // User accepts age
  const handleYes = () => {
    localStorage.setItem("ageVerified", "true");
    setShow(false);
  };

  // User declines
  const handleNo = () => {
    alert("You must be 21+ to enter this site.");
    window.location.href = "https://google.com";
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-[9999]">

      <div className="bg-white w-80 p-6 rounded-2xl shadow-xl text-center">
        <h2 className="text-xl font-bold mb-2">Age Verification</h2>
        <p className="text-gray-700 mb-5">Are you 21 years old or above?</p>

        <div className="flex justify-between gap-4">
          <button
            onClick={handleNo}
            className="w-full bg-gray-300 text-black py-2 rounded-lg font-semibold"
          >
            No
          </button>

          <button
            onClick={handleYes}
            className="w-full bg-green-600 text-white py-2 rounded-lg font-semibold"
          >
            Yes, I am 21+
          </button>
        </div>
      </div>

    </div>
  );
};

export default AgePopup;
